export const ROLES = {
  OWNER: "OWNER",
  TENANT: "TENANT",
  COUNSELOR: "COUNSELOR",
  STAFF: "STAFF",
  CONTRACTOR: "CONTRACTOR",
  EXTERNAL_CONTACT: "EXTERNAL_CONTACT",
  TICKET_MANAGER: "TICKET_MANAGER",
};
